import {
  Home,
  Users,
  CreditCard,
  CalendarCheck,
  FileText,
  Calendar as CalendarIcon,
  MessageSquare,
  GitBranch,
  BookCheckIcon,
  Coffee,
  DollarSignIcon,
  GitPullRequestIcon,
  CalculatorIcon,
  Shield,
  LockIcon,
  Settings,
  Building2,
  Clock,
} from "lucide-react";

// Navigation menu items builder (receives runtime values)
export const buildAllNavItems = (t, isPrivateMessagingEnabled, unreadMessages, hasNewMessage, currentPage) => [
  { icon: Home, text: t.dashboard, page: "dashboard" },
  { icon: Users, text: t.employees, page: "employees" },
  { icon: CreditCard, text: t.payroll, page: "payroll" },
  // { icon: BarChart3, text: t.analytics, page: "analytics" },
  { icon: Clock, text: t.attendance, page: "attendance" },
  { icon: FileText, text: t.reports, page: "reports" },
  { icon: CalendarIcon, text: t.calendar, page: "calendar" },
  {
    icon: MessageSquare,
    text: isPrivateMessagingEnabled ? t.messages : `${t.messages} `,
    page: "messages",
    locked: !isPrivateMessagingEnabled,
  },
  {
    icon: GitBranch,
    text: t.EscalationGroupMapping,
    page: "EscalationGroupMapping",
  },
  {
    icon: BookCheckIcon,
    text: t.documentsManagement,
    page: "DocumentsManagement",
  },
  { icon: Coffee, text: t.leaveManagement, page: "LeaveApprovalPage" },
  {
    icon: DollarSignIcon,
    text: t.solfaManagement,
    page: "AdvancementsManagement",
  },
  { icon: GitPullRequestIcon, text: t.employeeChanges, page: "ChangesPage" },
  { icon: CalculatorIcon, text: t.taxCalculator, page: "TaxCalculator" },
  { icon: Shield, text: t.adminLevels, page: "adminLevels" },
  { icon: Building2, text: t.departments, page: "departments" },
  { icon: LockIcon, text: t.companyConfiguration, page: "configuration" },
  { icon: Settings, text: t.settings, page: "Settings" },
];